import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { openDropdownMenu, closeDropdownMenu, toggleDropdownMenu } from './actions'

function mapStateToProps(state, hocProps) {
    return {
        open: state.getIn(['ui', 'dropdown', hocProps.name, 'open']) || false,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ openDropdownMenu, closeDropdownMenu, toggleDropdownMenu }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
